<template>
  <div>
    <site-header />
    <main class="auth-page">
      <section class="auth-visual">
        <img :src="authImage" :alt="authImageAlt">
        <div>
          <p>Member Access</p>
          <h1>Track orders, save favorites, and checkout faster.</h1>
        </div>
      </section>
      <section class="auth-panel">
        <div class="auth-tabs">
          <button :class="{ active: mode === 'login' }" @click="mode = 'login'">Login</button>
          <button :class="{ active: mode === 'register' }" @click="mode = 'register'">Register</button>
        </div>
        <form @submit.prevent="submit">
          <label v-if="mode === 'register'">
            Full Name
            <input v-model="form.name" placeholder="Alex Chen">
          </label>
          <label>
            Email
            <input v-model="form.email" type="email" placeholder="you@example.com" required>
          </label>
          <label>
            Email Verification Code
            <div class="verify-row">
              <input v-model="form.verifyCode" placeholder="Enter 6-digit code" maxlength="6" required>
              <button type="button" :disabled="countdown > 0" @click="sendCode">
                {{ countdown > 0 ? `${countdown}s` : 'Send Code' }}
              </button>
            </div>
          </label>
          <label>
            Password
            <input v-model="form.password" type="password" placeholder="At least 6 characters" required>
          </label>
          <label v-if="mode === 'register'">
            Confirm Password
            <input v-model="form.confirmPassword" type="password" placeholder="Repeat password" required>
          </label>
          <button class="add-bag" type="submit">{{ mode === 'login' ? 'Sign In' : 'Create Account' }}</button>
        </form>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
  name: 'Auth',
  components: { SiteHeader, SiteFooter },
  data() {
    return {
      mode: 'login',
      form: {
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        verifyCode: ''
      },
      countdown: 0,
      timer: null,
      demoCode: ''
    }
  },
  computed: {
    authImage() {
      return this.mode === 'register'
        ? require('@/assets/img/home/look-denim-essentials.jpg')
        : require('@/assets/img/home/look-hoodie-cargo.jpg')
    },
    authImageAlt() {
      return this.mode === 'register' ? 'GearPulse denim essentials outfit' : 'GearPulse hoodie and cargo outfit'
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    sendCode() {
      if (!this.form.email) {
        this.$message.warning('Please enter your email first')
        return
      }

      if (this.timer) {
        clearInterval(this.timer)
      }

      this.demoCode = String(Math.floor(100000 + Math.random() * 900000))
      this.countdown = 60
      this.$message.success(`Verification code sent`)
      this.timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    submit() {
      this.$message.error('Email verification code is incorrect')
    }
  }
}
</script>
